export default __webpack_public_path__ + "static/media/topship-icon.f79c9a56.svg";